import { getDisplayName } from '../../helpers/react/getDisplayName';
import { isProduction } from '@olivierpascal/helpers';
import { isFragment } from './isFragment';
export const isElementLike = (element, expectedDisplayName) => {
    // eslint-disable-next-line no-console
    if (!isProduction() && isFragment(element)) {
        // eslint-disable-next-line no-console
        console.error("sixui: A component doesn't accept a Fragment as a child. Consider providing an array instead.");
    }
    const elementDisplayName = getDisplayName(element);
    const isLike = !!elementDisplayName?.endsWith(expectedDisplayName);
    return isLike;
};
